import { render } from "./BuyAttention.vue?vue&type=template&id=543e719a&scoped=true&ts=true"
import script from "./BuyAttention.vue?vue&type=script&lang=ts"
export * from "./BuyAttention.vue?vue&type=script&lang=ts"

import "./BuyAttention.vue?vue&type=style&index=0&id=543e719a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543e719a"]])

export default __exports__